import * as Atom from 'effect/unstable/reactivity/Atom';

export const showProductsComparisonDifferencesOnlyAtom = Atom.make(false);
